/**
 * @fileoverview Shared file validation and selection for Chat uploads.
 * @module pages/chat/chatFileUpload
 */
import { validateFile } from "../../logic/chat/index.js";

/** Validates a file and updates Chat upload state on the context. */
export const applyChatFileSelection = (ctx, file) => {
  if (!file) {
    return;
  }

  const validation = validateFile(file);
  if (validation.isValid) {
    ctx.setSelectedFile(file);
    ctx.setFileError("");
    return;
  }

  ctx.setSelectedFile(null);
  ctx.setFileError(validation.error);
};
